import React from 'react';

import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import DatePicker from 'material-ui/DatePicker';

class DateRangeSelector extends React.Component {
  constructor() {
    super(...arguments);
    this.state = {
      fromDate:null,
      toDate:null
    };

    this.setSubmitBtnDisabled = this.setSubmitBtnDisabled.bind(this);
  }

  setToDate = (event, date) => {
    this.setState({
      ...this.state,
      toDate: date
    });
  };

  setFromDate = (event, date) => {
    this.setState({
      ...this.state,
      fromDate: date,
    });
  };

  setSubmitBtnDisabled(){
    return !( this.state.fromDate!==null && this.state.toDate!==null );
  }

  submitDateRange(){
    const {fromDate, toDate} = this.state;
    const fromDateObj = new Date(fromDate);
    const toDateObj = new Date(toDate);

    const startRange = Date.UTC(fromDateObj.getFullYear(), fromDateObj.getMonth(), fromDateObj.getDate(), 0, 0, 0);
    const endRange = Date.UTC(toDateObj.getFullYear(), toDateObj.getMonth(), toDateObj.getDate(), 0, 0, 0);

    let fromDateISO = new Date(startRange).toISOString();
    let toDateISO = new Date(endRange).toISOString();
    this.props.handleCustomDateRange(fromDateISO, toDateISO);
  }
  render(){
    const actions = [
      <FlatButton
        label="Ok"
        primary={true}
        onTouchTap={this.submitDateRange.bind(this)}
        disabled={this.setSubmitBtnDisabled()}
      />,
      <FlatButton
        label="Cancel"
        onTouchTap={this.props.handleClose}
      />
    ];
    return (
      <div>
        <Dialog
          title="Custom Date Range"
          actions={actions}
          open={this.props.open}
          onRequestClose={this.props.handleClose}
        >
          Select Date Range
          <DatePicker
            hintText="From"
            value={this.state.fromDate}
            onChange={this.setFromDate}
            firstDayOfWeek={6}
          />
          <DatePicker
            hintText="To"
            value={this.state.toDate}
            onChange={this.setToDate}
            firstDayOfWeek={6}
          />
        </Dialog>
      </div>
    );

  }

}
export default DateRangeSelector;


// WEBPACK FOOTER //
// ./src/screens/stats/toolbar/DateRangeSelector.js